/*
 * @Author: ailin
 * @Date: 2022-11-01 13:24:48
 * @LastEditors: ailin
 * @LastEditTime: 2022-11-09 17:18:19
 * @Description: file content
 * @FilePath: /broadcast/src/theme/components/yzfdComponent/index.ts
 */
import { Component, Vue } from 'vue-property-decorator'
import _com from "@/assets/js/common";
import jsonp from "@/assets/js/http";

@Component
export default class yzfdComponent extends Vue {
  joinedShow: any = false
  noLuckShow: any = false
  listShow: any = false
  lottoryShow: any = false
  animateActive: any = false
  isOpenLottory: any = false
  timeout: any = 0
  showCenter: any = false
  blessTimer: any = null
  blessShow: any = false;//福袋活动是否开始
  isPartake: any = true //是否需要查询用户参与福袋
  // showTimer:any=true//是否展示倒计时时间
  canShow: any = false
  api = {
    attention: `https://pub${this.domain}/live/user/follow/changeUserFollowCallable`, // 关注或取消关注
    getAttentionStatus: `https://pub${this.domain}/live/user/follow`, // 获取关注状态
    blessingBag: `https://pub${process.env.VUE_APP_URI_DOMAIN}/ulelivebarrage/api/v1/user/blessingBag/win/`,//查询用户福袋活动是否中奖
    partake: `https://pub${process.env.VUE_APP_URI_DOMAIN}/ulelivebarrage/api/v1/user/blessingBag/partake/`,//查询用户是否已参与福袋
    sendBarrage: "https://pub" + this.domain + "/ulelivebarrage/api/v1/barrage/submit", //发送弹幕信息
    luckybag_text: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/indexFeaturedGet/luckybag_text/0/live_room_luckybag_text" // 福袋规则
  };
  notJoinShow: any = false
  statement: any = ''
  encryptionCode: any = ''
  joinedNumber: any = 0//参与人数
  browser = _com.browser();
  isEnd: any = false
  timerEnd: any = false//倒计时是否结束
  notFollowed: Boolean = false
  get blessingInfo() {
    //获取福袋活动信息
    return this.$store.getters["refresh/getBlessing"];
  }
  get bessingList() {
    //获取福袋中奖名单
    return this.$store.getters["refresh/getBessingList"];
  }
  get getCondition() {
    //获取是否开启了关注之后才能参与福袋
    return this.$store.getters["refresh/getCondition"];
  }
  get roomData() {//房间数据
    return this.$store.getters["getRoomDetail/getRoomDetail"];
  }
  get videoStatus() {
    let data = this.$store.getters["getRoomDetail/getStatus"];
    return data;
  }
  mounted() {
    _com.systemTime((difference: number) => {
      let nowTime = new Date().getTime() + difference
      this.init(difference);
    })
  }
  destroyed() {
    clearInterval(this.blessTimer);
  }
  //设置抽奖开始移入动画/抽奖结束按钮显示
  setAnimate(status: any) {
    let animateTimer = setTimeout(() => {
      if (status == 2) {
        // this.showTimer=true;//展示倒计时时间
        this.animateActive = true;
        this.canShow = true;//倒计时结束渲染福袋dom空间
      } else if (status == 3) {
        // this.isOpenLottory=true;
        this.animateActive = false;
      }
      clearTimeout(animateTimer);
    }, 2000);
  }
  knowFn() {
    this.showCenter = false
  }
  learnMore() {
    this.$http
      .jsonp(this.api.luckybag_text, {
        jsonp: "jsonpCallback",
        jsonpCallback: "luckybag_text",
      }).then((data: any) => {
        if (data.body.returnCode == '0000') {
          this.statement = data.body.indexInfo[0].show_text
          this.showCenter = true
          this.lottoryShow = false
        }
      })
  }
  //倒计时结束
  finished() {
    this.timeout = 0;
    this.getRecommendAsync();
    this.isEnd = true;
  }
  //初始化福袋活动
  init(difference: any) {
    let source = this.$route.params.source || this.source;
    //每秒查询一下是否有福袋活动信息，有信息进行相应设置
    this.blessTimer = setInterval(() => {
      // 红包雨查询,未登录或者非直播状态或邮掌柜环境不显示福袋信息
      if (!_com.getMallCookie() || this.videoStatus.roomStatus != 1 || this.browser.yzg || source == 'uzg') {
        clearInterval(this.blessTimer);
        return false;
      }
      let blessingInfo = this.blessingInfo;
      if (blessingInfo && blessingInfo.blessing_bag_setting && blessingInfo.blessing_bag_setting.end_time) {
        //有福袋活动信息时显示福袋活动
        this.blessShow = true;
        //有福袋活动信息，判断是否已结束，不是已结束则展示福袋活动
        let startTime = (new Date(blessingInfo.blessing_bag_setting.start_time.replace(/-/g, '/'))).getTime();
        let endTime = (new Date(blessingInfo.blessing_bag_setting.end_time.replace(/-/g, '/'))).getTime();
        let nowTime = (new Date()).getTime() + difference;
        //判断抽象是否结束，已结束展示抽奖结束动画
        if (blessingInfo.blessing_bag_setting.status == 2) {
          //抽奖进行中
          if (!this.timeout || !this.isEnd) {
            this.timeout = endTime - nowTime;//设置倒计时
            // console.log('==========倒计时时间',endTime,nowTime,this.timeout)
          }
          this.isOpenLottory = false;//福袋重新开始时，重置福袋状态
          this.timerEnd = false;
        } else if (blessingInfo.blessing_bag_setting.status == 3) {
          this.joinedShow = false;
          this.timeout = 0;
          this.isEnd = true;
        }
        this.setAnimate(blessingInfo.blessing_bag_setting.status);//设置抽奖开始移入动画/抽奖结束按钮显示
        //根据是否有中奖信息判断是否开奖，已开奖自动弹出一次中奖/未中奖弹框
        if (blessingInfo.blessing_bag_setting.status == 3 && blessingInfo.winner.winners && blessingInfo.winner.id) {
          this.autoShow(blessingInfo);
          this.joinedShow = false;
        }
      } else {
        this.blessShow = false;//没有福袋活动信息不展示福袋模块
      }
    }, 1000)
  }
  //自动展示抽奖结果
  async autoShow(blessingInfo: any) {
    if (!this.isPartake) {
      return false
    }
    let data: any = await this.queryJoined();
    if (data && !data.code) {
      this.isPartake = false
      setTimeout(() => {
        this.isPartake = true
      }, 70000);
      if (data.flag == 1) {
        //参与了抽奖显示抽奖结果
        //判断缓存中是否已存入福袋开奖id，有则判断当前的开奖id是否与缓存中的一样，不一样的话则调用中奖接口查询是否中奖；没有存入开奖id时将当前id存入缓存并查询是否中奖
        let blessId = localStorage.blessId;
        if (!blessId) {
          //查询用户是否参与抽奖，参与就自动展示抽奖结果，未参与不显示
          localStorage.blessId = blessingInfo.winner.id;
          this.openedHandler();
        } else {
          if (blessingInfo.winner.id != blessId) {
            localStorage.blessId = blessingInfo.winner.id;
            this.openedHandler();
          }
        }
      } else {
        this.canShow = false;//未参与直接隐藏
      }
      this.joinedNumber = data.total;
    }
  }
  //已开奖按钮点击事件
  async openedHandler() {
    //
    const callback = 'isWinning'
    jsonp(this.api.blessingBag + `${this.$route.params.roomNumber}/${callback}`, {
      room_name: this.$route.params.roomNumber,
      jsonp: 'callback',
      jsonpcallback: callback
    }).then((data: any) => {
      if (data.flag == 1) {
        this.encryptionCode = data.item_code
        //中奖了,显示中奖弹框
        this.lottoryShow = true;
        this.isOpenLottory = true;//中奖了显示一次中奖的小图标
      } else {
        this.canShow = false;//隐藏福袋dom空间
        this.noLuckShow = true;
      }
    }).catch(err => {
      console.log('err', err)
    });

  }
  //抽奖中点击事件
  async openingHandler() {
    try {
      let liveName = ''
      if (this.roomData.tvStatus == 0) liveName = '待开播'
      if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
      if (this.roomData.tvStatus == 2) liveName = '已结束'

      let ylw_Luckybag = {
        // ylw_live_id: this.roomData.id,
        // ylw_live_name: this.roomData.title,
        // ylw_live_type: liveName,
        ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
        ylw_live_id: this.roomData.id,
        ylw_live_name: this.roomData.title,
        ylw_live_type: liveName,
        roomNumber: this.roomData.roomNumber,
        scene_number: this.roomData.scene_number,
        theme: this.roomData.theme,
        ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid')

      }

      _com.sendSensorTrack('Luckybag', this.roomData, ylw_Luckybag, false, 'yshPoint')
      // _com.sendSensorTrack('直播间福袋点击', this.roomData, ylw_Luckybag, true, 'yshPoint')
    } catch (error) {

    }
    const callback = 'getfollow'
    let url = `${this.api.getAttentionStatus}?room_id=${this.$route.params.id}`
    jsonp(url, {
      jsonp: 'callback',
      jsonpcallback: callback
    }).then((res: any) => {
      this.notFollowed = this.getCondition != 1 || res.flag == 1
    })
    let data: any = await this.queryJoined();
    if (data && !data.code) {
      if (data.flag == 1) {
        //已参与
        this.joinedShow = true;
      } else {
        //未参与，显示一键参与弹框
        this.notJoinShow = true;
      }
      this.joinedNumber = data.total;
    }
  }
  //查询是否参与抽奖
  queryJoined() {
    return jsonp(this.api.partake + `${this.$route.params.roomNumber}/callback`, {
      room_name: this.$route.params.roomNumber,
      jsonp: 'callback',
      jsonpcallback: 'callback'
    }).then((data: any) => {
      return data;
    }).catch(err => {
      console.log('err', err)
      return err;
    });
  }
  //展示中奖名单
  showLuckList() {
    this.noLuckShow = false;
    this.listShow = true;
  }
  //一键参与抽奖,将关键字发到弹幕
  joinHandler() {
    if (!this.notFollowed) {
      let callback = "changeUserFollow";
      jsonp(
        `${this.api.attention}?room_id=${this.$route.params.id}&flag=${1}&originType=${this.roomData.tvType}&callback=${callback}`,
        {
          jsonpcallback: callback,
          jsonp: 'callback',
        }
      ).then((res: any) => {
        console.log(res, 'resres')
        this.$emit('followStatus', res.flag)
        this.notJoinShow = false
        if (res.flag == 1) this.$toast('关注成功')
        this.lottoryShow = false
      }).catch((res: any) => {
        console.log(res, 'resresres')
        this.$toast(res.msg)
      })
      // 关注埋点
      _com.sendSensorTrack('Focus', this.roomData, {})
    }
    let key = this.blessingInfo.blessing_bag_setting.key || '';
    if (!key) return;
    this.sendBarrage(key);
  }
  sendBarrage(key: any) {
    //发送直播间弹幕
    this.fetch({
      url: this.api.sendBarrage,
      data: {
        room_name: this.$route.params.roomNumber,
        content: key,
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    }).then((data: any) => {
      this.$toast("已成功参与福袋");
      this.$root.eventHub.$emit("getBarrage") //已成功参与福袋
      this.notJoinShow = false;
    }
    );
  }
  //直播间信息接口
  getRecommendAsync() {
    if (!this.timerEnd) {
      this.timerEnd = true;
      let source: any = this.$route.params.source || this.source;
      this.$store.dispatch("refresh/getRecommendAsync", {
        roomNumber: this.$route.params.roomNumber,
        source: source
      });
    }
  }
}


